export const AUTH_PASSWORD_RECOVERY_URL = '/password-recovery';
export const AUTH_URL = '/auth';

export const IDP_AUTH_INITIALISATION_URL = '/idp-auth-initialisation';
export const IDP_AUTH_LANDING_URL = '/idp-auth-landing';

export const BASE_URL = "/login"

export const getUrl = (url: string) => {
    return BASE_URL + url;
}
